export const CountryPermissions = {
  ViewAllCountry: {
    permissionsId: '20a0ebf1-73cf-4048-5236-08d9918483b8',
    permissionsName: 'View all country',
    componentsId: null,
    components: null
  },
  AddNewCountry: {
    permissionsId: '9c8c29a3-d16f-46fc-5237-08d9918483b8',
    permissionsName: 'Add new country',
    componentsId: null,
    components: null
  },
  EditCountry:
  {
    permissionsId: 'df1ddf39-4ed9-4074-5238-08d9918483b8',
    permissionsName: 'Edit country',
    componentsId: null,
    components: null
  }

};
